module.exports = __webpack_public_path__ + "img/animated-logo.16ecd150.gif";